export default "__VITE_ASSET__Z3ljir5R__"